import { FC } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { CourseCardSkeleton } from "../Skeleton/CourseCardSkeleton";
import classNames from "classnames";
import SwiperCore from "swiper";
import useSwiperProps from "@shared/hooks/useSwiperProps";

interface Props {
  hasAddToCart?: boolean;
  className?: string;
}

const SkeletonCourseList: FC<Props> = ({ hasAddToCart, className }) => {
  const swiperProps = useSwiperProps();
  return (
    <div
      className={classNames(
        "min-w-0 break-words bg-white w-full  overflow-x-hidden mb-3 courseCard relative",
        className
      )}
    >
      <Swiper
        init={false}
        onInit={(swiper: SwiperCore) => {
          swiper.isBeginning = true;
        }}
        onUpdate={(swiper: SwiperCore) => (swiper.isBeginning = true)}
        className="mb-2 grid"
        slidesPerView="auto"
        {...swiperProps}
      >
        {Array(6)
          .fill(0)
          .map((_, index) => (
            <SwiperSlide key={index} className="my-swiper-course-slide pb-1">
              <CourseCardSkeleton hasAddToCart={hasAddToCart} />
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
};

export default SkeletonCourseList;
